import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthenticator, Text } from "@aws-amplify/ui-react";

export default function ProtectedRoute({ children }) {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  const location = useLocation();

  if (authStatus === "configuring") {
    return <Text>Loading…</Text>;
  }

  if (authStatus !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
